<template>
  <div class="noWrap">      
    <v-btn icon color="primary"  @click="download">
      <v-icon center>mdi-download</v-icon>
    </v-btn>  
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FacturacionFaturaComponent',
  props: {
    value: {
      type: [String, Boolean, Array, Number],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          // eslint-disable-next-line no-unused-vars
          transform: (value, row) => value,
        }
      },
    },
    row: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    download() {
      axios({
        method: 'get',
        url: 'https://dev-colombia-files.s3.amazonaws.com/MANUAL.pdf',
        responseType: 'arraybuffer'
      })
      .then(response => {
        
        this.forceFileDownload(response)
        
      })
      .catch(() => console.log('error occured'))
    },
     forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `FATURA-${this.row['TRANSACTION_NUMBER']}.pdf`) 
      document.body.appendChild(link)
      link.click()
    },
  },
  data() {
    return {
      dialog: false,

    }
  },
}
</script>
